import reactStringReplace from 'react-string-replace';

import { TextButton } from '../common/buttons/TextButton';
import { translate } from '../common/helpers/translate.helper';
import { useOpenFreshchat } from '../common/hooks/useOpenFreshchat';

export const ApiKeyDescription = () => {
    const openFreshchat = useOpenFreshchat();

    return (
        <>
            {reactStringReplace(translate('apikey.description'), 'contact us', (match, i) => {
                return (
                    <TextButton key={i} onClick={openFreshchat}>
                        {match}
                    </TextButton>
                );
            })}
        </>
    );
};
